import { useState, useCallback } from "react";

// @mui material components
import { Grid, Card, MenuItem, FormControl, InputLabel, Select } from '@mui/material';
import ConfirmDialog from "components/ConfirmDialog";
import useConfirmDelete from "hooks/useConfirmDelete";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import DataTable from "examples/Tables/DataTable";
// import Switch from "@mui/material/Switch";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import { useSelector, useDispatch } from "react-redux";
import { Add, Remove } from "@mui/icons-material";

// Data
import tableData from "./data/tableData";

// Redux Stuff
import { createAlarm, deleteAlarm, updateAlarm } from "../../store/actions/alarms";


const Comp = () => {
  const dispatch = useDispatch()
  const list = useSelector((state) => state.dashboard.alarms)
  const locationList = useSelector((state) => state.dashboard.locations);
  const assetList = useSelector((state) => state.dashboard.assets);
  const [editMode, setEditMode] = useState(null)

  // const [name, setName] = useState("")
  const [description, setDescription] = useState("");
  const [speed, setSpeed] = useState(1800);
  const [sidebandHz, setSidebandHz] = useState(2);
  const [alertRatio, setAlertRatio] = useState(150);

  // const [unbalance, setUnbalance] = useState(50)
  // const [unbalanceT, setUnbalanceT] = useState({ threshold: 10 })

  // const [misalignment, setMisalignment] = useState(50)
  // const [misalignmentT, setMisalignmentT] = useState({ threshold: 10 })

  // const [BPFO, setBPFO] = useState(50)
  // const [BPFOT, setBPFOT] = useState({ threshold: 10 })

  // const [BPFI, setBPFI] = useState(50)
  // const [BPFIT, setBPFIT] = useState({ threshold: 10 })

  // // const [shaftSway, setShaftSway] = useState(50)
  // // const [shaftSwayT, setShaftSwayT] = useState({ threshold: 10 })

  // const [looseness, setLooseness] = useState(50)
  // const [loosenessT, setLoosenessT] = useState({ threshold: 10 })

  // const [cavitation, setCavitation] = useState(50)
  // const [cavitationT, setCavitationT] = useState({ threshold: 10 })

  const [slLocation, setSLLocation] = useState(0);
  const [slName, setSLName] = useState(0);

  const [faults, setFaults] = useState({});

  console.log("HERE: ", Object.entries(faults));

  const updateSLName = (e) => {
    console.log('updateSLName: ', e.target.value);
    setSLName(e.target.value)
  }
  const handleChangeLocation = (event) => {
    setSLLocation(event.target.value);
  };

  const refreshFields = () => {
    setEditMode(null);
    // setName("");
    setDescription("");
    setSLLocation(0);
    setSLName(0);
    setSpeed(1800);
    setSidebandHz(2);
    setAlertRatio(150);
    setFaults({});
  }

  const doDelete = useCallback((id) => {
    dispatch(deleteAlarm(id));
    refreshFields();
  }, [dispatch]);

  const { confirmOpen, requestDelete, handleConfirm, handleCancel } = useConfirmDelete(doDelete);

  const deleteList = (id) => {
    requestDelete(id);
  }

  const editList = (i, flag) => {
    const item = list[i]
    if (!flag) {
      setEditMode(item)
      // setName(item.name)
      setDescription(item.description)

      const findAsset = assetList.find(asset => asset.name === item.name);
      if (findAsset) {
        const findLocation = locationList.find(location => location.pk.toString() === findAsset.location);
        if (findLocation) {
          setSLLocation(findLocation.pk)
        }
        setSLName(findAsset.pk);
      } else {
        setSLName(0);
      }
    }

    const { json_data } = item
    setSpeed(json_data.speed ? json_data.speed : 1800);
    setSidebandHz(json_data.sidebandHz ? json_data.sidebandHz : 2);
    setAlertRatio(json_data.alertRatio ? json_data.alertRatio : 150);
    setFaults(json_data.faults ? json_data.faults : {});

    // setUnbalance(json_data.unbalance)
    // setUnbalanceT(Object.fromEntries(
    //   Object.entries(json_data.unbalanceT).filter(([key]) => key !== "Notification")
    // ))

    // setMisalignment(json_data.misalignment)
    // setMisalignmentT(Object.fromEntries(
    //   Object.entries(json_data.misalignmentT).filter(([key]) => key !== "Notification")
    // ))

    // setBPFO(json_data.BPFO)
    // setBPFOT(Object.fromEntries(
    //   Object.entries(json_data.BPFOT).filter(([key]) => key !== "Notification")
    // ))

    // setBPFI(json_data.BPFI)
    // setBPFIT(Object.fromEntries(
    //   Object.entries(json_data.BPFIT).filter(([key]) => key !== "Notification")
    // ))

    // // setShaftSway(json_data.shaftSway)
    // // setShaftSwayT(Object.fromEntries(
    // //   Object.entries(json_data.shaftSwayT).filter(([key]) => key !== "Notification")
    // // ))

    // setLooseness(json_data.looseness)
    // setLoosenessT(Object.fromEntries(
    //   Object.entries(json_data.loosenessT).filter(([key]) => key !== "Notification")
    // ))

    // setCavitation(json_data.cavitation)
    // setCavitationT(Object.fromEntries(
    //   Object.entries(json_data.cavitationT).filter(([key]) => key !== "Notification")
    // ))

  }

  const showData = tableData(list, deleteList, editList);
  // const updateName = (e) => setName(e.target.value);
  const updateDescription = (e) => setDescription(e.target.value);

  const updateSpeed = (e) => setSpeed(e.target.value);
  const updateSidebandHz = (e) => setSidebandHz(e.target.value);
  const updateAlertRatio = (e) => setAlertRatio(e.target.value);

  // const updateUnbalance = (e) => setUnbalance(e.target.value);
  // const updateUnbalanceT = (e, key) => {
  //   const newThreshold = { ...unbalanceT }
  //   newThreshold[key] = e.target.value
  //   setUnbalanceT(newThreshold)
  // }

  // const updateMisalignment = (e) => setMisalignment(e.target.value);
  // const updateMisalignmentT = (e, key) => {
  //   const newThreshold = { ...misalignmentT }
  //   newThreshold[key] = e.target.value
  //   setMisalignmentT(newThreshold)
  // }

  // const updateBPFO = (e) => setBPFO(e.target.value);
  // const updateBPFOT = (e, key) => {
  //   const newThreshold = { ...BPFOT }
  //   newThreshold[key] = e.target.value
  //   setBPFOT(newThreshold)
  // }

  // const updateBPFI = (e) => setBPFI(e.target.value);
  // const updateBPFIT = (e, key) => {
  //   const newThreshold = { ...BPFIT }
  //   newThreshold[key] = e.target.value
  //   setBPFIT(newThreshold)
  // }

  // // const updateShaftSway = (e) => setShaftSway(e.target.value);
  // // const updateShaftSwayT = (e, key) => {
  // //   const newThreshold = { ...shaftSwayT }
  // //   newThreshold[key] = e.target.value
  // //   setShaftSwayT(newThreshold)
  // // }

  // const updateLooseness = (e) => setLooseness(e.target.value);
  // const updateLoosenessT = (e, key) => {
  //   const newThreshold = { ...loosenessT }
  //   newThreshold[key] = e.target.value
  //   setLoosenessT(newThreshold)
  // }

  // const updateCavitation = (e) => setCavitation(e.target.value);
  // const updateCavitationT = (e, key) => {
  //   const newThreshold = { ...cavitationT }
  //   newThreshold[key] = e.target.value
  //   setCavitationT(newThreshold)
  // }

  const addNewFault = () => {
    setFaults(prevState => ({
      ...prevState,
      NewFault: { frequency: 50, threshold: 10 }
    }));
  }

  const removeFault = () => {
    const newFaults = { ...faults };
    const keys = Object.keys(newFaults);
    if (keys.length > 0) {
      delete newFaults[keys[keys.length - 1]];
      setFaults(newFaults);
    }
  }

  const updateSubmit = () => {

    // const json_data = {
    //   speed, sidebandHz, alertRatio, unbalance, unbalanceT, misalignment, misalignmentT, BPFO, BPFOT, BPFI, BPFIT, looseness, loosenessT, cavitation, cavitationT
    // }

    const json_data = {
      speed, sidebandHz, alertRatio, faults
    }

    if (slName !== 0) {
      const newAsset = assetList.find(asset => asset.pk === slName);

      if (newAsset) {
        if (editMode)
          dispatch(updateAlarm(editMode.pk, newAsset.name, description, json_data));
        else
          dispatch(createAlarm(newAsset.name, description, json_data));

        refreshFields();
      }
    }
  }

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={1} className="systems">
          <Grid item xs={12} md={3}>
            <Card>
              <MDBox
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
                mx={2}
                mt={-3}
                p={2}
                mb={1}
                textAlign="center"
              >
                <MDTypography variant="h4" fontWeight="medium" color="white" mt={1}>
                  Radar Chart Settings
                </MDTypography>
              </MDBox>

              <MDBox pt={4} pb={3} px={3}>
                <MDBox component="form" role="form">

                  <MDBox mb={1.5}>
                    <div className="select-control">
                      <FormControl sx={{ m: 0, width: '100%' }}>
                        <InputLabel id="demo-simple-select-helper-label">Group Name</InputLabel>

                        <Select
                          labelId="demo-simple-select-helper-label"

                          value={slLocation}

                          onChange={handleChangeLocation}
                        >
                          <MenuItem value={0}>
                            <em>None</em>
                          </MenuItem>
                          {
                            locationList.map(item => <MenuItem key={item.pk} value={item.pk}>{item.name}</MenuItem>)
                          }
                        </Select>
                      </FormControl>
                    </div>
                  </MDBox>
                  <MDBox mb={1.5}>
                    <div className="select-control">
                      <FormControl sx={{ m: 0, width: '100%' }}>
                        <InputLabel id="demo-simple-select-helper-label">Asset ID</InputLabel>

                        <Select
                          labelId="demo-simple-select-helper-label"

                          value={slName}

                          onChange={updateSLName}
                        >
                          <MenuItem value={0}>
                            <em>None</em>
                          </MenuItem>
                          {
                            assetList.filter(asset => slLocation === 0 ? asset : asset.location === slLocation.toString()).map(item => <MenuItem key={item.pk} value={item.pk}>{item.name}</MenuItem>)
                          }
                        </Select>
                      </FormControl>
                    </div>
                  </MDBox>

                  {/* <MDBox mb={1.5}>
                    <MDInput type="text" label="Asset ID" fullWidth value={name} onChange={updateName} />
                  </MDBox> */}

                  <MDBox mb={5}>
                    <MDInput type="text" label="Description" fullWidth value={description} onChange={updateDescription} />
                  </MDBox>

                  <MDBox mb={1.5}>
                    <MDInput type="number" className="label-amp" label="Speed (RPM)" required fullWidth value={speed} onChange={updateSpeed} />
                  </MDBox>

                  <MDBox mb={1.5}>
                    <MDInput type="number" className="label-amp" label="Sideband (Hz)" fullWidth value={sidebandHz} onChange={updateSidebandHz} />
                  </MDBox>

                  <MDBox mb={5}>
                    <MDInput type="number" className="label-amp" label="Alarm/Alert ratio (%)" fullWidth value={alertRatio} onChange={updateAlertRatio} />
                  </MDBox>

                  <MDBox mb={1.5} style={{ display: 'flex', justifyContent: 'flex-end' }} >
                    <Add style={{ color: 'blue', cursor: 'pointer' }} onClick={() => addNewFault()} />
                  </MDBox>

                  {/* <MDBox mb={1.5}>
                    <MDInput type="number" className="label-amp" label="Unbalance(Hz)" fullWidth value={unbalance} onChange={updateUnbalance} />
                  </MDBox>

                  <MDBox mb={2}>
                    <Grid container spacing={0.5}>
                      {
                        Object.keys(unbalanceT).map((key) => 
                        <Grid item xs={6} key={key}>
                          <MDInput type="number" label={key} fullWidth value={unbalanceT[key]} onChange={(e) => updateUnbalanceT(e, key)} />
                        </Grid>)
                      }
                    </Grid>
                  </MDBox>

                  <MDBox mb={1.5}>
                    <MDInput type="number" className="label-amp" label="Misalignment(Hz)" fullWidth value={misalignment} onChange={updateMisalignment} />
                  </MDBox>
                  <MDBox mb={2}>
                    <Grid container spacing={0.5}>
                      {
                        Object.keys(misalignmentT).map((key) => 
                        <Grid item xs={6} key={key}>
                          <MDInput type="number" label={key} fullWidth value={misalignmentT[key]} onChange={(e) => updateMisalignmentT(e, key)} />
                        </Grid>)
                      }
                    </Grid>
                  </MDBox>

                  <MDBox mb={1.5}>
                    <MDInput type="number" className="label-amp" label="BPFO(Hz)" fullWidth value={BPFO} onChange={updateBPFO} />
                  </MDBox>
                  <MDBox mb={2}>
                    <Grid container spacing={0.5}>
                      {
                        Object.keys(BPFOT).map((key) => 
                        <Grid item xs={6} key={key}>
                          <MDInput type="number" label={key} fullWidth value={BPFOT[key]} onChange={(e) => updateBPFOT(e, key)} />
                        </Grid>)
                      }
                    </Grid>
                  </MDBox>

                  <MDBox mb={1.5}>
                    <MDInput type="number" className="label-amp" label="BPFI(Hz)" fullWidth value={BPFI} onChange={updateBPFI} />
                  </MDBox>
                  <MDBox mb={2}>
                    <Grid container spacing={0.5}>
                      {
                        Object.keys(BPFIT).map((key) => 
                        <Grid item xs={6} key={key}>
                          <MDInput type="number" label={key} fullWidth value={BPFIT[key]} onChange={(e) => updateBPFIT(e, key)} />
                        </Grid>)
                      }
                    </Grid>
                  </MDBox>

                  {/* <MDBox mb={1.5}>
                    <MDInput type="number" className="label-amp" label="Shaft Sway" fullWidth value={shaftSway} onChange={updateShaftSway} />
                  </MDBox>
                  <MDBox mb={2}>
                    <Grid container spacing={0.5}>
                      {
                        Object.keys(shaftSwayT).map((key) => <Grid item xs={6} key={key}>
                          <MDInput type="number" label={key} fullWidth value={shaftSwayT[key]} onChange={(e) => updateShaftSwayT(e, key)} />
                        </Grid>)
                      }
                    </Grid>
                  </MDBox> */}

                  {/* <MDBox mb={1.5}>
                    <MDInput type="number" className="label-amp" label="Looseness(Hz)" fullWidth value={looseness} onChange={updateLooseness} />
                  </MDBox>
                  <MDBox mb={2}>
                    <Grid container spacing={0.5}>
                      {
                        Object.keys(loosenessT).map((key) => 
                        <Grid item xs={6} key={key}>
                          <MDInput type="number" label={key} fullWidth value={loosenessT[key]} onChange={(e) => updateLoosenessT(e, key)} />
                        </Grid>)
                      }
                    </Grid>
                  </MDBox>

                  <MDBox mb={1.5}>
                    <MDInput type="number" className="label-amp" label="Cavitation(Hz)" fullWidth value={cavitation} onChange={updateCavitation} />
                  </MDBox>
                  <MDBox mb={2} style={{ display: 'flex', alignItems: 'center' }} >
                    <Grid container spacing={0.5}>
                      {
                        Object.keys(cavitationT).map((key) => 
                        <Grid item xs={6} key={key}>
                          <MDInput type="number" label={key} fullWidth value={cavitationT[key]} onChange={(e) => updateCavitationT(e, key)} />
                        </Grid>)
                      }
                    </Grid>
                  </MDBox> */}

                  {
                    Object.entries(faults).map(([key, value], index) => (
                      // eslint-disable-next-line react/no-array-index-key
                      <MDBox mt={4} mb={4} key={index}>
                        <MDBox mb={1.5}>
                          <MDInput 
                            type="text" 
                            className="label-amp" 
                            label="Name" 
                            fullWidth 
                            value={key}
                            onChange={(e) => {
                            const newKey = e.target.value;
                            if (newKey !== key) {
                              // Create new object with preserved order
                              const newFaults = {};
                              Object.entries(faults).forEach(([k, v]) => {
                                if (k === key) {
                                  newFaults[newKey] = v;
                                } else {
                                  newFaults[k] = v;
                                }
                              });
                              setFaults(newFaults);
                            }
                          }} 
                        />
                        </MDBox>
                        <MDBox mb={2} style={{ display: 'flex', alignItems: 'center' }} >
                          <Grid container spacing={1}>
                            <Grid item xs={12} sm={5}>
                              <MDInput
                                type="number"
                                className="label-amp"
                                label="Frequency(Hz)"
                                fullWidth
                                value={value.frequency}
                                onChange={(e) => setFaults(prevState => ({
                                  ...prevState,
                                  [key]: { ...prevState[key], frequency: e.target.value }
                                }))}
                              />
                            </Grid>
                            <Grid item xs={10} sm={5}>
                              <MDInput
                                type="number"
                                label="threshold"
                                fullWidth
                                value={value.threshold}
                                onChange={(e) => setFaults(prevState => ({
                                  ...prevState,
                                  [key]: { ...prevState[key], threshold: e.target.value }
                                }))}
                              />
                            </Grid>
                            <Grid item xs={2} sm={2} style={{ display: 'flex', alignItems: 'center' }}>
                              <Remove style={{ color: 'red', cursor: 'pointer' }} onClick={() => removeFault()} />
                            </Grid>
                          </Grid>
                        </MDBox>
                      </MDBox>
                    ))
                  }

                  {/* <MDBox mb={2} >
                    <MDBox mb={1.5}>
                      <MDInput type="text" className="label-amp" label="Name" fullWidth value={cavitation} onChange={updateCavitation} />
                    </MDBox>
                    <MDBox mb={2} style={{ display: 'flex', alignItems: 'center' }} >
                      <Grid container spacing={1}>
                        <Grid item xs={6}>
                          <MDInput type="number" className="label-amp" label="Frequency(Hz)" fullWidth />
                        </Grid>
                        <Grid item xs={5}>
                          <MDInput type="number" label="threshold" fullWidth />
                        </Grid>
                      </Grid>
                    </MDBox>
                  </MDBox> */}

                  <MDBox mt={4} mb={1}>
                    <MDButton variant="gradient" color={editMode ? "success" : "info"} fullWidth onClick={updateSubmit}>
                      {editMode ? "Update" : "Add"}
                    </MDButton>
                  </MDBox>

                  <MDBox mt={1} mb={1}>
                    <MDButton variant="gradient" color="error" fullWidth onClick={refreshFields}>
                      Cancel
                    </MDButton>
                  </MDBox>

                </MDBox>
              </MDBox>
            </Card>
          </Grid>

          <Grid item xs={12} md={9}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
              >
                <MDTypography variant="h6" color="white">
                  Alarm List
                </MDTypography>
              </MDBox>
              <MDBox pt={3}>
                <DataTable
                  table={showData}
                  isSorted={false}
                  entriesPerPage={false}
                  showTotalEntries={false}
                  noEndBorder
                />
              </MDBox>
            </Card>
          </Grid>

        </Grid>
      </MDBox>
      <ConfirmDialog
        open={confirmOpen}
        title="Delete Alarm"
        message="Are you sure you want to delete this alarm configuration?"
        onConfirm={handleConfirm}
        onCancel={handleCancel}
      />
      <Footer />
    </DashboardLayout>
  );
}

export default Comp;
